import React from 'react';
import { ShieldAlert, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Button from '@/components/common/Button';
import { useActiveRole } from '@/hooks/useActiveRole';
import { RoutesLink } from '@/utility/RouteLinks';
import { Header } from '@/components/Layout/Header';

const Forbidden403: React.FC = () => {
    const navigate = useNavigate();
    const { prefix } = useActiveRole();

    const handleGoBack = () => {
        // Go back to the user's dashboard based on their role prefix
        navigate(`${prefix}${RoutesLink.dashboard}`, { replace: true });
    };

    return (
        <div className="min-h-screen flex flex-col bg-background">
            <Header mobileOpen={false} setMobileOpen={() => { }} />
            <div className="flex-1 flex items-center justify-center px-4 py-12">
                <div className="max-w-md w-full flex flex-col items-center text-center space-y-6 bg-card p-10 rounded-2xl border border-border shadow-sm">

                    {/* Visual Icon */}
                    <div className="relative">
                        <div className="absolute inset-0 bg-red-100/50 dark:bg-red-900/20 rounded-full blur-xl transform scale-150 animate-pulse"></div>
                        <div className="relative bg-red-100 dark:bg-red-900/30 p-4 rounded-full">
                            <ShieldAlert className="w-12 h-12 text-red-600 dark:text-red-500" />
                        </div>
                    </div>

                    {/* Text Content */}
                    <div className="space-y-3">
                        <h1 className="text-4xl font-extrabold text-foreground tracking-tight">403</h1>
                        <h2 className="text-xl font-semibold text-foreground">Access Forbidden</h2>
                        <p className="text-base text-muted-foreground leading-relaxed">
                            You don't have the required permissions to view this page. If you believe this is a mistake, please contact your administrator.
                        </p>
                    </div>

                    {/* Call to Action */}
                    <div className="w-full pt-4">
                        <Button
                            onClick={handleGoBack}
                            variant="primary"
                            className="w-full flex items-center justify-center gap-2"
                            size="lg"
                            leftIcon={<ArrowLeft className="w-4 h-4" />}
                        >
                            Return to Dashboard
                        </Button>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default Forbidden403;
